export default __webpack_public_path__ + "static/media/products.4703a48d.svg";